import * as React from 'react';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import AddchartIcon from '@mui/icons-material/Addchart';
import AddHomeIcon from '@mui/icons-material/AddHome';
import DI from '../../../utility/DI';
// import EditIcon from '@mui/icons-material/Edit';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import NavigationIcon from '@mui/icons-material/Navigation';

function FloatingAdd(props) {
  const {
    di: { session,},
  } = props;
  return (
  <div style={{position:'fixed',bottom:'3vh',right:'20px'}}    >
      <Box sx={{ '& > :not(style)': { m: 1 } }}>
      <Fab color="secondary" aria-label="add" onClick={()=>props.onclick('room_expense')}>
        <AddchartIcon/>
      </Fab>
      <Fab  color="warning" aria-label="edit" disabled={!session?.homes?.length}  onClick={()=>props.onclick('home_expense')}>
        <AddHomeIcon />
      </Fab>
    </Box>
  </div>
  );
}
export default DI(FloatingAdd)